/* global theme */
/*
 * SPEC-13 — Recently Viewed products.
 *
 * Comportamento:
 *  1. Em toda PDP: registra o product.handle no localStorage (LRU max 12).
 *  2. Em containers [data-recently-viewed-container]: fetcha cards via Shopify
 *     Section Rendering API e injeta no DOM.
 *
 * Privacy: localStorage com handles (não-PII). Sem cookies.
 * Storage key: 'altogiro:recently-viewed'.
 * LRU: array ordenado (mais recente primeiro), dedupe, max 12 entries.
 *
 * Section used: sections/recently-viewed-products.liquid (recebe handles via
 * query string ?recent=h1,h2,h3 e renderiza product-block pra cada).
 */
(function () {
  if (window.__recentlyViewedInit) return;
  window.__recentlyViewedInit = true;

  var STORAGE_KEY = 'altogiro:recently-viewed';
  var MAX_ENTRIES = 12;
  var SECTION_ID = 'recently-viewed-products';

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h.length > 0; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // QuotaExceeded ou Safari Private mode — silently no-op
    }
  }

  /**
   * Registra um handle no topo da lista (LRU).
   * Pula se o handle atual já é o último visualizado (não inflar).
   */
  function track(handle) {
    if (!handle || typeof handle !== 'string') return;
    var list = readList();
    // Remove ocorrência anterior (dedupe)
    list = list.filter(function (h) { return h !== handle; });
    // Adiciona no topo
    list.unshift(handle);
    // Trunca em MAX_ENTRIES
    if (list.length > MAX_ENTRIES) list = list.slice(0, MAX_ENTRIES);
    writeList(list);
  }

  /**
   * Em PDP, descobre o handle do produto atual pelo path.
   * /products/<handle> ou /products/<handle>?variant=...
   */
  function detectCurrentHandle() {
    var path = window.location.pathname || '';
    var match = path.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  /**
   * Injeta os cards de produtos recentemente visualizados no(s) container(s).
   * Exclui o produto atual (não tem sentido mostrar o que você está vendo).
   */
  /**
   * DEEP-OPT E.3: usa data-rv-state em .recently-viewed (em vez de container.style.display)
   * pra que CSS controle visibilidade SEM CLS:
   *   - "loading": section reserva altura via CSS min-height
   *   - "populated": section visible, altura definida pelo conteúdo real
   *   - "empty": section completamente oculta via CSS (display: none)
   */
  function setSectionState(state) {
    document.querySelectorAll('.recently-viewed').forEach(function (sec) {
      sec.setAttribute('data-rv-state', state);
    });
  }

  function renderContainers() {
    var containers = document.querySelectorAll('[data-recently-viewed-container]');
    if (!containers.length) return;

    var currentHandle = detectCurrentHandle();
    var list = readList().filter(function (h) { return h !== currentHandle; });

    // Sem produtos pra mostrar — esconde section inteira (sem deixar heading órfão)
    if (!list.length) {
      setSectionState('empty');
      return;
    }

    // Limita a quantos cards o container pediu (data-max="N"), max global = 8
    var sliced = list.slice(0, 8);

    // FIX: preserva query string original (ex: preview_theme_id em ambiente dev).
    // Sem isso, Section Rendering API caía no tema LIVE em vez do tema de preview,
    // retornando section vazia se o LIVE ainda não tem 'recently-viewed-products'.
    var existingQuery = window.location.search || '';
    var sep = existingQuery ? '&' : '?';
    var url = window.location.pathname + existingQuery + sep +
      'section_id=' + encodeURIComponent(SECTION_ID) +
      '&recent=' + encodeURIComponent(sliced.join(','));

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Section fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        // A response da Section Rendering API vem com o section wrapper.
        // Extrair só o conteúdo útil pra injetar.
        var temp = document.createElement('div');
        temp.innerHTML = html;
        // O markup interno está dentro do section wrapper. Se a section
        // renderizar markup vazio (nenhum produto válido), abortar.
        var inner = temp.querySelector('[data-recently-viewed-inner]');
        if (!inner || !inner.children.length) {
          setSectionState('empty');
          return;
        }
        containers.forEach(function (c) {
          c.innerHTML = inner.innerHTML;
        });
        setSectionState('populated');
      })
      .catch(function () {
        // Falha silenciosa — esconder pra não mostrar "buraco"
        setSectionState('empty');
      });
  }

  function init() {
    // Em PDP, registrar a visualização
    var currentHandle = detectCurrentHandle();
    if (currentHandle) {
      track(currentHandle);
    }

    // Renderizar containers (PDP outros + cart-drawer empty state)
    renderContainers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
